<template>
    <!--    <BasicLayout>-->
    <el-container style="padding: 0px">
        <el-aside width="240px">
            <el-row type="flex" justify="start" align="middle" class="topTab"
                    @click.native=""><span></span></el-row>
            <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==1}"
                    @click.native="dashboard1"><span>工作汇报</span></el-row>
            <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==2}"
                    @click.native="dashboard2"><span>客户覆盖</span></el-row>
            <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==3}"
                    @click.native="dashboard3"><span>销量达成</span></el-row>
            <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==4}"
                    @click.native="dashboard4"><span>辖区概述</span></el-row>
            <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==5}"
                    @click.native="dashboard5"><span>协访分析</span></el-row>
        </el-aside>
        <el-main>

            <keep-alive :include="includePageNames">
                <!-- includePageNames是数组，用来存放需要缓存的页面的路由中的path或者name的 -->
                <router-view></router-view>
            </keep-alive>
        </el-main>
    </el-container>
</template>

<script>
    import axios from 'axios'
    import http from '../../APIService/http'
    // import BasicLayout from "../../components/navHeader";
    import  {bus} from '../../router/index'

    export default {
        name: "index",
        components:{
            // BasicLayout
        },
        data(){
            return {
                active:1,
                options:[],
                includePageNames:[]
            }
        },
        created(){

            // this.active = localStorage.getItem('active')
        },
        mounted(){
            // this.getManager()
        },
        watch: {
            // '$route' (to, from) {
            //     if (to.name === 'travel' || to.name === 'jurisdictionInfo' ){
            //         this.includePageNames.push('travel')
            //     }else {
            //         this.includePageNames = []
            //     }
            // }
        },
        methods:{
            dashboard1(){
                this.$router.push({
                    path:'/dashBoard/workReport'
                })
                localStorage.setItem('active',1)
                this.active = localStorage.getItem('active')
            },
            dashboard2(){
                this.$router.push({
                    path:'/dashBoard/customersCovered'
                })
                localStorage.setItem('active',2)
                this.active = localStorage.getItem('active')
            },
            dashboard3(){
                this.$router.push({
                    path:'/dashBoard/salesReached'
                })
                localStorage.setItem('active',3)
                this.active = localStorage.getItem('active')
            },
            dashboard4(){
                this.$router.push({
                    path:'/dashBoard/summarize'
                })
                localStorage.setItem('active',4)
                this.active = localStorage.getItem('active')
            },
            dashboard5(){
                this.$router.push({
                    path:'/dashBoard/Analyze'
                })
                localStorage.setItem('active',5)
                this.active = localStorage.getItem('active')
            },
            // dashboard2(){
            //     this.$router.push({
            //         path:'/calendar/weekPlan'
            //     })
            //     localStorage.setItem('active',2)
            //     this.active = localStorage.getItem('active')
            // },
            // dashboard3(){
            //     this.$router.push({
            //         path:'/calendar/evection'
            //     })
            //     localStorage.setItem('active',3)
            //     this.active = localStorage.getItem('active')
            // },
            // dashboard5(){
            //     this.$router.push({
            //         path:'/calendar/cultivate'
            //     })
            //     localStorage.setItem('active',4)
            //     this.active = localStorage.getItem('active')
            // },
        },
        beforeRouteLeave(to, from, next) {
            localStorage.setItem('active',1)

            next();
        },
        beforeRouteUpdate(to, from, next) {
            if (to.name === 'DashBoard') {
                this.active = 1
            }
            next();
        }
    }
</script>

<style scoped>
    .topTab{
        font-size: 18px;
        height: 60px;
        padding-left:40px ;
        color: #bbbbbb;
    }
    .el-aside{
        background: #F4F6F8;
        padding: 15px 0;
        /*border: 1px solid #DCDFE6;*/
    }
    .el-main{
        background: white;
        /*border: 1px solid #DCDFE6;*/
        border-left: none;
        padding: 34px 20px;
    }
    .options{
        cursor: pointer;
        height: 45px;
        font-family: 'Hiragino Sans GB';
        font-size: 16px;
        color: #323232;
        padding-left:70px ;
        user-select: none;
    }

    .ico1:before{

        content: '';
        display: inline-block;
        width: 20px;
        height: 20px;
        text-align: center;
        background: url("../../assets/images/Fill2.png") no-repeat center;
        margin-right:20px ;
        background-size: cover;
    }
    .ico2:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        background: url("../../assets/images/ico1.png") no-repeat center;
        margin-right:20px ;
        background-size: contain;
    }
    .ico3:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        background: url("../../assets/images/diction1.png") no-repeat center;
        margin-right:20px ;
        background-size: contain;
    }
    .ico4:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        background: url("../../assets/images/dataBank2.png") no-repeat center;
        margin-right:20px ;
        background-size: contain;
    }
    .ico5:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        background: url("../../assets/images/systemParameter1.png") no-repeat center;
        margin-right:20px ;
        background-size: contain;
    }
    .ico6:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        background: url("../../assets/images/productSku1.png") no-repeat center;
        margin-right:20px ;
        background-size: contain;
    }
    /* .options:hover{
         color: white;
         background: #409EFF;
     }
     .options:hover .ico1:before{
         background: url("../../assets/images/Fill1.png") no-repeat center;
     }
     .options:hover .ico2:before{
         background: url("../../assets/images/ico2.png") no-repeat center;
     }*/
    .optionsActive{
        cursor: pointer;
        height: 45px;
        font-family: Hiragino Sans GB;
        font-size: 16px;
        color: #323232;
        padding-left:70px ;
        user-select: none;
        color: #3998F7;
        font-weight: bold;
    }
    .ico1A:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        margin-right:20px ;
        background: url("../../assets/images/Fill1.png") no-repeat center;
        background-size: contain;
    }
    .ico2A:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        margin-right:20px ;
        background: url("../../assets/images/ico2.png") no-repeat center;
        background-size: contain;
    }
    .ico3A:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        margin-right:20px ;
        background: url("../../assets/images/diction2.png") no-repeat center;
        background-size: contain;
    }
    .ico4A:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        margin-right:20px ;
        background: url("../../assets/images/dataBank1.png") no-repeat center;
        background-size: contain;
    }
    .ico5A:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        margin-right:20px ;
        background: url("../../assets/images/systemParameter2.png") no-repeat center;
        background-size: contain;
    }
    .ico6A:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        margin-right:20px ;
        background: url("../../assets/images/productSku2.png") no-repeat center;
        background-size: contain;
    }
    .el-container{
        min-height: 100%;
    }

</style>



// WEBPACK FOOTER //
// src/pages/dashboard/index.vue